/* eslint-disable no-console */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button';

import * as css from './Email.scss';

class Email extends Component {
	constructor(props) {
		super(props);

		this.emailInputRef = createRef();

		this.state = {
			isValid: false,
		};
	}

	isEmailValid = email => {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line

		return re.test(String(email).toLowerCase());
	};

	onClose = () => {
		this.props.onCloseClick();
	};

	onChange = e => {
		this.setState({ isValid: this.isEmailValid(e.currentTarget.value) });
	};

	onSubmit = e => {
		const { selected } = this.props;
		const email = this.emailInputRef.current.value;

		if (this.isEmailValid(email)) {
			// analytics.onSendEmail();
			this.props.onSubmit(email, selected);
			this.props.onCloseClick();
		}

		e.preventDefault();
	};

	render() {
		const { isValid } = this.state;

		return (
			<div className={css.email}>
				<div className={css.emailContent}>
					<div className={css.innerContent}>
						<form>
							<p className={css.title}>הזינו כתובת מייל:</p>
							<input
								className={css.emailInput}
								id="email"
								type="text"
								placeholder="my-email@mail.co.il"
								onChange={this.onChange}
								ref={this.emailInputRef}
							/>
							<div className={css.submitWrap}>
								<Button size={Button.SMALL} disabled={!isValid} onClick={this.onSubmit} type="button">
									שלח
								</Button>
							</div>
							<button className={css.close} onClick={this.onClose} type="button">
								<span>בטל</span>
							</button>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

Email.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	selected: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	onCloseClick: PropTypes.func.isRequired,
};

export default Email;
